import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';
import {useDocument} from "react-firebase-hooks/firestore";

export default function useDogCarouselData(dogId) {
    const { firestore } = useFirebaseProviders();
    const [dogRef, loading, error] = useDocument(firestore.collection('dogs').doc(dogId),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
    return [dogRef?.data()?.images?.map(({src})=>src) || [], loading, error];

}
